/**
 * Created by Ivan on 26.08.2026
 */

Placements.ENTRIES["hungryGamesLoseSequence"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const customer = HungryGamesCustomer.findCustomer();
        return Boolean(customer && customer.needLoseSequence);
    },

    action: function () {
        HungryGamesCustomer.findCustomer().runLoseSequence();
    }
};

Placements.ENTRIES["hungryGamesCompleteSequence"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const customer = HungryGamesCustomer.findCustomer();
        return Boolean(customer && customer.getCustomer().getState() === Customer.STATE_READY);
    },

    action: function () {
        HungryGamesCustomer.findCustomer().runCompleteSequence();
    }
};
